import React from 'react';
import { FaLanguage, FaGlobe } from 'react-icons/fa';
import './Languages.css';

const Languages = () => {
  const languages = [
    {
      name: "Hindi",
      level: "Native",
      dots: 5,
      description: "Fluent in speaking, reading, and writing"
    },
    {
      name: "English",
      level: "Advanced",
      dots: 4,
      description: "Professional proficiency in technical communication"
    }
  ];

  const renderDots = (totalDots, filledDots) => {
    const dots = [];
    for (let i = 0; i < totalDots; i++) {
      dots.push(
        <div 
          key={i} 
          className={`dot ${i < filledDots ? 'filled' : ''}`}
        />
      );
    }
    return dots;
  };

  return (
    <section id="languages" className="languages">
      <div className="container">
        <h2 className="section-title">
          <FaLanguage className="title-icon" />
          Language Proficiency
        </h2>
        
        <div className="languages-content">
          <div className="languages-intro">
            <FaGlobe className="intro-icon" />
            <h3>Communication Skills</h3>
            <p>
              Effective communication is crucial in software development. I'm proficient in multiple languages 
              and can collaborate effectively in diverse, international teams.
            </p>
          </div>
          
          <div className="languages-grid">
            {languages.map((language, index) => (
              <div key={index} className="language-card">
                <div className="language-header">
                  <h4>{language.name}</h4>
                  <span className="language-level">{language.level}</span>
                </div>
                
                <div className="language-dots">
                  {renderDots(5, language.dots)}
                </div>
                
                <p className="language-description">{language.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Languages;
